var pathfix = function pathfix(path) {
    return path.split(/[\\\/]+/).join('/');
};

const path = (pagepath) => pathfix('app/pages/' + pagepath);

function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

function mapModel(shuffledIMap, models) {
    var arrtemp = [];
    for (var i = 0; i < models.length; i++) {
        arrtemp.push(models[shuffledIMap[i]]);
    }
    return arrtemp;
}